var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTick = function SvgTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 22.25,
    y1: 148.56,
    x2: 162.46,
    y2: 23.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M195.71,31.43c-5.71-5.71-14.29-5.71-20,0l-107.14,107.14-44.29-44.29c-5.71-5.71-14.29-5.71-20,0-5.71,5.71-5.71,14.29,0,20l54.29,54.29c2.86,2.86,5.71,4.29,10,4.29s7.14-1.43,10-4.29l117.14-117.14c5.71-5.71,5.71-14.29,0-20h0Z",
    style: {
      fill: "url(#b)",
      strokeWidth: 0
    }
  }));
};
export default SvgTick;